import { Typography, Stack } from '@mui/material';
import TypingEffect from './typing-effect';

const MainHeader = ({hisName, herName}) => {
    return (
        <Stack direction={{sm: 'column', md: 'row' }} justifyContent='center' alignItems='center'>
            <Typography variant="h1"><TypingEffect value={hisName || "Input Name"} /></Typography>
            <Typography variant="h3" sx={{ margin: "1.5rem -1rem 1.5rem 2rem" }}><TypingEffect value={"and"} delay={0.4} /></Typography>
            <Typography variant="h1"><TypingEffect value={herName || "Input Name"} delay={0.6} /></Typography>
        </Stack>     
    )
}

export default MainHeader;
